export const getSelectedValue = (array: any[], value: string) => {
  return array.find((data) => data.value === value);
};
export const readFile = (file: File) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
};